import { useGetEventTeamResultsBySessionQuery } from '../state/api';
import TeamCompetitionSesionResultTable from './team-competition-sesion-result-table';

interface TeamCompetitionSessionResultsTableContainerProps {
  teamCompID: string | null | undefined;
}

const TeamCompetitionSesionResultTableContainer = ({
  teamCompID,
}: TeamCompetitionSessionResultsTableContainerProps) => {
  const { data: results = [] } = useGetEventTeamResultsBySessionQuery(teamCompID!, {
    skip: teamCompID == null,
  });

  return <TeamCompetitionSesionResultTable results={results} />;
};

export default TeamCompetitionSesionResultTableContainer;
